import Vue from "vue";
import App from "./App";

import store from "./store";
import ElementUI from "element-ui";
import "./css/index.css";
import "element-ui/lib/theme-chalk/index.css";
import userCenterRouter from "@/router/index";
import router from "./router";
import { GetQueryString } from "@/util/validator";
// import { getsubscribeStatus, formatUser } from "@/util/index";

import { getAzure } from "../api/";
import { Message, Alert } from "element-ui";
import Cookies from "js-cookie";

Vue.use(ElementUI);
console.log("------------------main-----------------");
Vue.config.productionTip = false;

// 测试及本地调试时显示，可以免除登录，直接进入  ，正式隐藏
// Vue.prototype.$goLogin = () => {
//     window.localStorage.setItem('openid', 'opPcI1DVZmOAWq3fEaMR4AqiTYgY')
//     window.localStorage.setItem('memberOf', 1)
//     window.localStorage.setItem('email', '2660047536111@qq.com')
//     window.localStorage.setItem('displayname', '1111')

//     store.dispatch('setSAMLResponse', { openid: 'opPcI1DVZmOAWq3fEaMR4AqiTYgY', email: '2660047536111@qq.com', displayname: '111', memberOf: 1 });

//     getsubscribeStatus(window.localStorage.getItem('openid'))
//     window.localStorage.setItem('date', new Date().getTime())
// };

// 提交正式时显示，这是登录判断的部分，
Vue.prototype.$goLogin = () => {

  if (GetQueryString("s")) {
    console.log(GetQueryString("s"))
    
    let parms = {
      s: GetQueryString("s")
    };
    getAzure(parms).then(res => {      
      console.log(res.data.data)
      let data = res.data.data;
      console.log(data)
      if(data.memberOf==null){
        Message({
          message: "memberOf为空，没有权限",
          type: "warning"
        });
      }
            localStorage.clear();
            //截取字符串
            var d = data.memberOf.lastIndexOf("#");
            var mem =
              d > -1
                ? data.memberOf.substring(0, d)
                : data.memberOf;
            var memberOf = menber(mem);
            console.log(memberOf)
            //保存用户信息到本地
            window.localStorage.setItem("openid",data.id);
            window.localStorage.setItem("memberOf", memberOf);
            window.localStorage.setItem("email", data.email);
            window.localStorage.setItem("displayname",data.displayName);
            //处理权限，并隐藏链接上的用户信息
            store.dispatch("setSAMLResponse", {
              openid: data.id,
              email: data.email,
              displayname: data.displayName,
              memberOf: memberOf
            });
            // getsubscribeStatus(window.localStorage.getItem("openid"));
            window.localStorage.setItem("date", new Date().getTime());
            if (
              window.localStorage.getItem("openid") ||
              window.localStorage.getItem("email") ||
              window.localStorage.getItem("memberOf")
            ) {
              var url = window.location.href; //获取当前页面的url
              console.log(url)
              if (url.indexOf("?") != -1) {
                //判断是否存在参数
                url = url.replace(/(\?|#)[^'"]*/, ""); //去除参数
                window.history.pushState({}, 0, url);
                // this.$router.push("/#/admin");
              }
            }
    });
  }
  //根据链接上返回的字符串，解析用户信息，并保存到本地
  else if (
    GetQueryString("openid") ||
    GetQueryString("email") ||
    GetQueryString("displayname") ||
    GetQueryString("memberOf")
  ) {
    localStorage.clear();
    //截取字符串
    var d = GetQueryString("memberOf").lastIndexOf("#");
    var mem =
      d > -1
        ? GetQueryString("memberOf").substring(0, d)
        : GetQueryString("memberOf");
    var memberOf = menber(mem);
    //保存用户信息到本地
    window.localStorage.setItem("openid", GetQueryString("openid"));
    window.localStorage.setItem("memberOf", memberOf);
    window.localStorage.setItem("email", GetQueryString("email"));
    window.localStorage.setItem("displayname", GetQueryString("displayname"));
    //处理权限，并隐藏链接上的用户信息
    store.dispatch("setSAMLResponse", {
      openid: GetQueryString("openid"),
      email: GetQueryString("email"),
      displayname: GetQueryString("displayname"),
      memberOf: memberOf
    });
    console.log(GetQueryString("displayname"));
    // getsubscribeStatus(window.localStorage.getItem("openid"));
    window.localStorage.setItem("date", new Date().getTime());
    if (
      window.localStorage.getItem("openid") ||
      window.localStorage.getItem("email") ||
      window.localStorage.getItem("memberOf")
    ) {
      var url = window.location.href; //获取当前页面的url
      if (url.indexOf("?") != -1) {
        //判断是否存在参数
        url = url.replace(/(\?|#)[^'"]*/, ""); //去除参数
        // window.history.pushState({}, 0, url);
        this.$router.push("/#/admin");
      }
    }
  }
};

// 处理返回来的权限
function menber(value) {
  var memberOf = "";
  var inFifteenMinutes = new Date(new Date().getTime() + 8 * 60 * 60 * 1000);
  
  // 检查各种权限并设置相应的cookies和权限级别
  if (value.indexOf("Intel Partner Wechat_Reporting_Prod_View_SuperUsers") > -1) {
    // 超级管理员权限
    memberOf = "1";
  } 
  
  if (value.search("Intel Partner Wechat_Reporting_Prod_View_TrainingAdmins") > -1) {
    // 培训管理员权限
    memberOf = memberOf == "1" ? memberOf : "2";
  }
  
  if (value.indexOf("Intel Partner Wechat_Reporting_Prod_View_IntelPMs") > -1) {
    // 内部PM权限
    if (memberOf == "" || memberOf == "4") {
      memberOf = "3";
    }
  }
  
  // 检查新增的权限类型并设置相应的cookies
  if (value.indexOf("COFUtility_Viewer") > -1) {
    Cookies.set("cofreport", true, {expires: inFifteenMinutes, path: '/', domain: "partnersocial.intel.cn"});
    if (memberOf == "") {
      memberOf = "4";
    }
  }
  
  if (value.indexOf("ICS_Wechat_Dashboard_viewer") > -1) {
    Cookies.set("icsreport", true, {expires: inFifteenMinutes, path: '/', domain: "partnersocial.intel.cn"});
    if (memberOf == "") {
      memberOf = "4";
    }
  }
  
  if (value.indexOf("IPA_Wechat_Dashboard_viewer") > -1) {
    Cookies.set("ipareport", true, {expires: inFifteenMinutes, path: '/', domain: "partnersocial.intel.cn"});
    if (memberOf == "") {
      memberOf = "4";
    }
  }
  
  // 其他Agent权限
  if (value.indexOf("Intel Partner Wechat Reporting_Prod_Read_Agents") > -1) {
    if (memberOf == "") {
      memberOf = "4";
    }
  }
  
  if (value.indexOf("Intel Partner Wechat Report Platform") > -1) {
    if (memberOf == "") {
      memberOf = "4";
    }
  }

  return memberOf;
}

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js